import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(7px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 13px;
  margin-bottom: 20px;
`;

const Card = styled.div`
  background: #fff;
  border: 1px solid #E8DDD6;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 1px 4px rgba(22, 17, 13, 0.06);
  transition: box-shadow 0.2s, transform 0.2s;
  animation: ${fadeUp} 0.32s ease both;
  animation-delay: ${({ delay }) => delay || 0}ms;
  &:hover {
    box-shadow: 0 4px 16px rgba(22, 17, 13, 0.09);
    transform: translateY(-2px);
  }
`;

const Emoji = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;

const Count = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ color }) => color};
`;

const Label = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #16110D;
  margin-top: 4px;
`;

const Sub = styled.div`
  font-size: 11px;
  color: #B8AAA2;
  margin-top: 2px;
  min-height: 14px;
`;

const StatCards = ({ summary, loading }) => {
  const val = key => {
    if (loading) return '—';
    return summary ? (summary[key] ?? 0).toLocaleString() : '—';
  };

  const compliance =
    summary && summary.total_companies > 0
      ? `${((summary.abn_count / summary.total_companies) * 100).toFixed(1)}% compliance`
      : '';

  const cards = [
    {
      emoji: '🏢',
      value: val('total_companies'),
      label: 'Total Companies',
      sub: 'active companies',
      color: '#F36E21',
      delay: 0,
    },
    {
      emoji: '🏪',
      value: val('places_linked'),
      label: 'Places Linked',
      sub: 'linked across all companies',
      color: '#1E5FAA',
      delay: 50,
    },
    {
      emoji: '✅',
      value: val('abn_count'),
      label: 'ABN Verified',
      sub: compliance,
      color: '#1A7A4A',
      delay: 100,
    },
    {
      emoji: '💳',
      value: val('bank_details_count'),
      label: 'Bank Details Set',
      sub: 'ready for settlement',
      color: '#00B28C',
      delay: 150,
    },
  ];

  return (
    <Grid>
      {cards.map(({ emoji, value, label, sub, color, delay }) => (
        <Card key={label} delay={delay}>
          <Emoji>{emoji}</Emoji>
          <Count color={color}>{value}</Count>
          <Label>{label}</Label>
          <Sub>{sub}</Sub>
        </Card>
      ))}
    </Grid>
  );
};

export default StatCards;
